let paramBoiler: any = {
    UserId: [],
    FirstName: [],
    MiddleName: [],
    LastName: [],
    DisplayName: [],
    EmployeeNumber: [],
    PTOPlanId: [],
    UserName: [],
    Inactive: [],
    WorkEmail: [],
    HomeProfitCenterId: [],
    HomeProfitCenter: [],
    WorkPhone: [],
    SupervisorID: [],
    Supervisor: [],
    Address1: [],
    Address2: [],
    City: [],
    State: [],
    ZipCode: [],
    JobTitle: [],
    HasIncident: [],
    HasOpenIncident: []
}

export default paramBoiler